// Module
var code = "<div class=\"actions-loading-modal\"> <div class=\"loader\"> <preloader-dot preloader-size=\"md\"></preloader-dot> </div> <h3> Generating Report... </h3> </div> ";
// Exports
module.exports = code;